import React from 'react';
import ConnectionPopup from '../connectionPopup';
import { isMobile } from '../../../core/helpers/isMobile';

function ConnectionPopupWrapper() {
  return <ConnectionPopup x={isMobile() ? 0 : 534} y={isMobile() ? 0 : 308} />;
}
export default ConnectionPopupWrapper;
